import { render, staticRenderFns } from "./market-makers.vue?vue&type=template&id=23fddc65"
import script from "./market-makers.vue?vue&type=script&lang=js"
export * from "./market-makers.vue?vue&type=script&lang=js"
import style0 from "./market-makers.vue?vue&type=style&index=0&id=23fddc65&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/market-makers-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fmembers%2Fmarket-makers.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/market-makers-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fmembers%2Fmarket-makers.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,LoaderAnimation: require('/vercel/path0/components/ui/LoaderAnimation.vue').default,MemberCard: require('/vercel/path0/components/MemberCard.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default,FloatingModal: require('/vercel/path0/components/FloatingModal.vue').default})
